module.exports = __webpack_public_path__ + "img/star-stroke.f229827a.svg";